import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-gauge',
  templateUrl: './gauge.component.html',
  styleUrls: ['./gauge.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class GAUGEComponent {
  @Input() needleData: number;
  @Input() nps: boolean;
  @Input() smileyValue: boolean;

  public mapValueToRange(value: number): number {
    if (value == null || !Number.isFinite(value)) {
      return 0;
    }
    const degrees = this.nps ? (value / 100) * 90 : (value / 100) * 180 - 90;
    return Math.max(-90, Math.min(90, degrees));
  }
}
